// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b2ebff9e","453":"7cbd65b3","455":"79133c21"}[chunkId] + ".chunk.js";
};